import { getHexagonShapes } from './get-hexagon-shapes.js';
import type { Point } from '../../core/types/point.js';
import { getShapeLinesBisect } from '../../core/utils/get-shape-lines-bisect.js';

export const getHexagonGeometry = (x: number, y: number, width: number) => {
  const { hexagonVertexes, textArea } = getHexagonShapes(x, y, width);
  const hexagonLinesBisect = getShapeLinesBisect(hexagonVertexes);

  const hexagonGeometry: Point[] = [];

  for (let i = 0; i < 6; i++) {
    hexagonGeometry.push(hexagonVertexes[i]);
    hexagonGeometry.push(hexagonLinesBisect[i]);
  }

  // We need to close the path rounding the initial point as well.
  hexagonGeometry.push(hexagonVertexes[0]);
  hexagonGeometry.push(hexagonLinesBisect[0]);

  return { hexagonGeometry, textArea };
};
